export default "__VITE_ASSET__hvvboqFI__"